import { useInfiniteQuery, useQuery } from '@tanstack/react-query';
import type { SearchResponse } from '@cop/shared';
import { api } from '@/lib/api';
import { useSession } from '@/lib/session';
import { useLocation } from 'react-router';
export function useSearchSurface() {
  const { pathname } = useLocation();
  return pathname.startsWith('/platform') ? '/platform/search' : pathname.startsWith('/portal') ? '/portal/search' : '/search';
}
export function useGlobalResults(params: Record<string, string | number>, enabled = true) {
  const session = useSession();
  const path = useSearchSurface();
  const surface = path.startsWith('/platform') ? 'platform' : 'workspace';
  return useQuery({ queryKey: ['global-search', session.user?.id, session.principal, surface, params], queryFn: ({ signal }) => api.get<SearchResponse>('/search', { ...params, surface }, { signal }), enabled: enabled && !!session.user, staleTime: 0, gcTime: 0, retry: false });
}
export function searchUrl(path: string, query: string, module = '') {
  const params = new URLSearchParams({ q: query.trim().slice(0, 200) });
  if (module) params.set('module', module);
  return `${path}?${params}`;
}

export function useGlobalPages(params: Record<string, string>, enabled = true) {
  const session = useSession(), path = useSearchSurface();
  const surface = path.startsWith('/platform') ? 'platform' : 'workspace';
  return useInfiniteQuery({ queryKey: ['global-search-pages', session.user?.id, session.principal, surface, params], initialPageParam: 0,
    queryFn: ({ pageParam, signal }) => api.get<SearchResponse>('/search', { ...params, surface, offset: pageParam, limit: 8 }, { signal }),
    getNextPageParam: (last, pages) => { const count = pages.reduce((n, page) => n + page.records.length, 0); return count < last.total && last.records.length ? count : undefined; },
    enabled: enabled && !!session.user, retry: false, staleTime: 0, gcTime: 0,
  });
}
